module.exports = __webpack_public_path__ + "media/assets/pngs/welcomeCarousel2-60072feefbe144c6be021f89742d2777.png";